<div class="pt-0 text-align-center grid" >
    <div class="col-6 flex align-items-center"><b>Vista Previa</b>
    </div>
    <div class="col-4">
        <button pButton pRipple type="button" icon="pi pi-print" class="p-button-rounded p-button-success" label="Imprimir" (click)="tipoImpresora? imprimirImpresoraTermica() : imprimir()"  [style]="{width: '10vw'}"></button>
    </div>
</div>
    <div *ngIf="arqueo" class="d-flex ">
        <div  class="d-flex flex justify-content-center">
            <div  id="print-cierre" class="card" style="width: 220px; padding: 10px; font-size: small;">
                <p *ngIf="arqueo?.impreso" >*******REIMPRESO*******</p>
                <p >*******Cierre de Turno*******</p>
                <p class="mb-0">SUCURSAL: {{ arqueo.nombre_sucursal | uppercase}} - {{arqueo.direccion_sucursal | uppercase}}</p>
                <p class="mb-0">FECHA APERTURA: {{ arqueo.fecha_apertura | date: 'dd/MM/yyy' }}</p>
                <p class="mb-0">HORA DE APERTURA: {{ arqueo.fecha_apertura | date: 'HH:mm:ss' }}</p>
                <p class="mb-0">FECHA DE CIERRE: {{ arqueo.fecha_cierre | date: 'dd/MM/yyy' }}</p>
                <p class="mb-0">HORA DE CIERRE: {{ arqueo.fecha_cierre | date: 'HH:mm:ss' }}</p>
                <p class="mb-0">CAJERO: {{ arqueo.nombre_cajero }}</p>
                <p class="mb-0">NRO ARQUEO: {{ arqueo.nro_arqueo | uppercase}}</p>
                <p>******************************</p>
                <p>MONTO APERTURA: {{ arqueo.importe_apertura  | currency: '':'':'0.0':'es-PY'}}</p>
                <p>******************************</p>
                <p>TOTAL INGRESO: {{ arqueo.total_ingreso  | currency: '':'':'0.0':'es-PY'}}</p>
                <p>TOTAL EGRESO: {{ arqueo.total_egreso  | currency: '':'':'0.0':'es-PY'}}</p>
                <p>SALDO (I-E): {{ arqueo.total_ingreso - arqueo.total_egreso  | currency: '':'':'0.0':'es-PY'}}</p>
                <p>******************************</p>
                <p>NRO DE TRANSACCIONES: {{ arqueo.cantidad_ingreso + arqueo.cantidad_egreso  | currency: '':'':'0.0':'es-PY'}}</p>
                <p>******************************</p>
                <p>*******{{arqueo.nombre_empresa}}*******</p>
                <p>{{arqueo.fecha_impresion | date: 'dd/MM/yyy' }}, {{ arqueo.fecha_impresion | date: 'HH:mm:ss' }}</p>
            </div>
        </div>
    </div>
